// removed by extract-text-webpack-plugin
module.exports = {"header":"UserHeader__header--3I3es","content":"UserHeader__content--3ARYM","avatar":"UserHeader__avatar--35Eky","displayName":"UserHeader__displayName--eulDr","bioContainer":"UserHeader__bioContainer--3wnaB","bio":"UserHeader__bio--3Ruer","socialIcons":"UserHeader__socialIcons--Jwta6","icon":"UserHeader__icon--phWeW","bounce":"UserHeader__bounce--1akYi"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Library/UserHeader/UserHeader.css
// module id = ./src/components/Library/UserHeader/UserHeader.css
// module chunks = 2